export const isProductionEnvironment = document.location.hostname.includes('regisroadrunners.co.uk')